import React from "react";
import styled from "styled-components";
import ContractIMG from "../../assets/images/contract.png";

const WrapperLegal = ({ title, content, para }) => {
	return (
		<Wrapper>
			<div className='container'>
				<div className='row'>
					<div className='col-md-12'>
						<h1>{title}</h1>
						<p>{para}</p>
					</div>
				</div>
				<div className='row align-items-center'>
					<div className='col-md-6'>
						<div className='scrollbar'>{content}</div>
					</div>
					<div className='col-md-6'>
						<img
							className='img-fluid px-5 px-md-0'
							src={ContractIMG}
							alt='contract'
						/>
					</div>
				</div>
			</div>
		</Wrapper>
	);
};

export default WrapperLegal;

const Wrapper = styled.section`
	background: #132779c2;
	padding: 50px 0;
	h1 {
		color: white;
		text-align: center;
		font-weight: 900;
		font-size: 40px;
		margin-bottom: 30px;
	}
	p {
		color: white;
		font-size: 18px;
		margin: 1em 0;
	}
	a {
		color: #3cdbc0;
		font-weight: bold;
	}

	.scrollbar {
		border-radius: 8px;
		overflow-y: scroll;
		background: #f0f0f0;
		padding: 30px 35px;
		max-height: 500px;
		main {
			padding: 1rem;
		}

		&::-webkit-scrollbar-track {
			-webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
			background-color: #f5f5f5;
			border-radius: 8px;
		}
		&::-webkit-scrollbar {
			width: 8px;
			background-color: #f5f5f5;
			border-radius: 8px;
		}
		&::-webkit-scrollbar-thumb {
			border-radius: 8px;
			background-color: #5268c2;
		}
		h2 {
			margin: 1rem 0;
			font-weight: 900;
		}

		p {
			font-size: 15px;
			margin: 1em 0;
			color: black;
		}
		ul {
			margin: 1em 0;
		}
		li {
			margin: 1em 0 1em 2em;
			list-style-type: circle;
		}
		a {
			color: #3cdbc0;
			font-weight: bold;
		}
	}

	@media (max-width: 767px) {
		padding: 30px 0;
		h1 {
			font-size: 24px;
		}
		.scrollbar {
			margin-bottom: 30px;
		}
	}
`;
